'use client'

import { produce } from 'immer'
import { useRouter, usePathname, useSearchParams } from 'next/navigation'

import { BodyObjectView } from 'utility/utility'
import { SessionFeaturedFragment, Enum_Componentbodysessionbrowser_Dateformat as DateFormat } from 'generated/graphql'
import { TheatreFilters } from './TheatreFilters'

import styles from './ComponentBodySessionBrowser.module.scss'

export const SessionFilterList: BodyObjectView<{
    sessions: readonly [SessionFeaturedFragment,React.ReactNode][],
    theatres: string[],
    days: string[],
    dateFormat: DateFormat | null
}> =
    ({
        sessions,
        theatres,
        days,
        dateFormat
    }) => {

        const router = useRouter()
        const pathname = usePathname()
        const searchParams = useSearchParams()

        const theatre = searchParams.get('theatre')

        const updateQuery = (updates: { [key: string]: string } ): void => {
            const params = produce(Object.fromEntries(searchParams.entries()), draft => {
                Object.entries(updates).forEach( ([field,value]) => {
                    if ( value === 'all' ) {
                        delete draft[field]
                    }
                    else {
                        draft[field] = value
                    }
                })
            })
            const query = new URLSearchParams([...Object.entries(params)])
            router.replace(
                `${pathname}${ query.size === 0 ? '' : `?${query.toString()}` }`,
                { scroll: false }
            )
        }

        const setTheatre = (theatre: string): void =>
            updateQuery({theatre})

        return (
            <>
                {
                    theatres.length < 2 ? <></> :
                        <TheatreFilters theatres={theatres} value={theatre} onChange={setTheatre} />
                }
                <section data-days={days.length} className={styles.Columns}>
                    {
                        days.map ( day =>
                            <section key={day} className={styles.Day}>
                                <h1> Day {days.indexOf(day) + 1} </h1>
                                <h1>
                                    {
                                        day === null || day === undefined ? <></> :
                                            dateFormat === DateFormat.Eu ?
                                                new Date(day).getUTCDate() + " " + new Date(day).toLocaleString('default', { timeZone: "UTC", month: 'long' })
                                                + " " + new Date(day).getUTCFullYear()
                                            : dateFormat === DateFormat.Na ?
                                                new Date(day).toLocaleString('default', { timeZone: "UTC", month: 'long' }) + " "
                                                + new Date(day).getUTCDate() + ", " + new Date(day).getUTCFullYear()
                                            :
                                                new Date(day).getUTCDate() + " " + new Date(day).toLocaleString('default', { timeZone: "UTC", month: 'long' })
                                                + " " + new Date(day).getUTCFullYear()
                                    }
                                </h1>
                                <ul data-number={sessions.length} className={styles.Sessions}>
                                    {
                                        sessions
                                            .filter( ([session]) => session?.date === day )
                                            .sort( ([a], [b]) =>
                                                (a?.start === null || a?.start === undefined ? "" : a.start).localeCompare(b?.start === null || b?.start === undefined ? "" : b.start)
                                            )
                                            .map( ([session,sessionView]) =>
                                                session === null || session === undefined || ( theatre !== null && session.theatre?.data?.attributes?.title !== theatre ) ? <></> :
                                                    <li key={session.name}>
                                                        {sessionView}
                                                    </li>
                                            )
                                    }
                                </ul>
                            </section>
                        )
                    }
                </section>
            </>
        )

    }

